import React from "react";
import { Typography, Button, Divider } from "antd";
import { CloseCircleOutlined, EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface ReviewSummaryCardProps {
  title: string;
  stepNumber: number;
  isComplete: boolean;
  onEdit: () => void;
  content: React.ReactNode;
}

const ReviewSummaryCard: React.FC<ReviewSummaryCardProps> = ({
  title,
  stepNumber,
  isComplete,
  onEdit,
  content,
}) => {
  return (
    <div
      className={`form-summary-card ${
        !isComplete ? "error-card" : "success-card"
      }`}
    >
      <div className="form-summary-card-header">
        <div className="form-summary-card-header-title">
          <span
            className={`form-summary-card-header-number ${
              isComplete ? "success" : "error"
            }`}
          >
            {isComplete ? stepNumber : <CloseCircleOutlined />}
          </span>
          <Text strong>{title}</Text>
        </div>
        <Button type="text" icon={<EditOutlined />} onClick={onEdit}>
          Edit
        </Button>
      </div>
      <Divider style={{ margin: 0 }} />

      <div className="form-summary-card-content">{content}</div>
    </div>
  );
};

export default ReviewSummaryCard;
